import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackfillEventosCustoService {
  private readonly http = inject(HttpClient);
  private readonly base = '/api/backfill-eventos-custo';

 
  importarGrupo(dataInicio?: string, dataFim?: string): Observable<BackfillResponse> {
    const url = `${this.base}/grupo`;
    const params: any = {};
    
    if (dataInicio) params.dataInicio = dataInicio;
    if (dataFim) params.dataFim = dataFim;

    return this.http.get<BackfillResponse>(url, { params });
  }


  importarDisparo(disparoId: number): Observable<BackfillResponse> {
    return this.http.post<BackfillResponse>(`${this.base}/disparo/${disparoId}`, {});
  }

  importarUltimoMes(): Observable<BackfillResponse> {
    return this.http.get<BackfillResponse>(`${this.base}/ultimo-mes`);
  }
}

export interface BackfillResponse {
  grupoId?: number;
  disparoId?: number;
  dataInicio?: string;
  dataFim?: string;
  periodo?: string;
  eventosImportados: number;
}